import React from 'react';
export function GreenLinesBackground() {
  return <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-5">
      <style data-id="element-6">{`
        @keyframes drawLine {
          0% { stroke-dashoffset: 5000; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes drawLineReverse {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 5000; }
        }
        @keyframes floatLine {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-30px, 20px); }
        }
        @keyframes floatLineReverse {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(30px, -20px); }
        }
        @keyframes floatDiagonal {
          0%, 100% { transform: translate(0, 0); }
          33% { transform: translate(20px, -15px); }
          66% { transform: translate(-15px, 25px); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.15; }
          50% { opacity: 0.4; }
        }
        @keyframes driftDot {
          0% { transform: translate(0, 0) scale(1); opacity: 0.3; }
          25% { transform: translate(40px, -30px) scale(1.3); opacity: 0.5; }
          50% { transform: translate(80px, 10px) scale(1); opacity: 0.3; }
          75% { transform: translate(40px, 40px) scale(0.8); opacity: 0.5; }
          100% { transform: translate(0, 0) scale(1); opacity: 0.3; }
        }
        @keyframes driftDotSlow {
          0% { transform: translate(0, 0) scale(1); opacity: 0.2; }
          33% { transform: translate(-50px, 30px) scale(1.2); opacity: 0.4; }
          66% { transform: translate(30px, -40px) scale(0.9); opacity: 0.2; }
          100% { transform: translate(0, 0) scale(1); opacity: 0.2; }
        }
        .animate-path-1 { 
          animation: drawLine 15s linear infinite, floatLine 12s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-2 { 
          animation: drawLine 20s linear infinite reverse, floatLineReverse 15s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-3 { 
          animation: drawLine 12s linear infinite, floatLine 10s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-4 { 
          animation: drawLine 18s linear infinite reverse, floatLineReverse 14s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-5 { 
          animation: drawLine 25s linear infinite, floatLine 18s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-6 { 
          animation: drawLineReverse 22s linear infinite, floatDiagonal 16s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-7 { 
          animation: drawLine 14s linear infinite, floatLineReverse 11s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-path-8 { 
          animation: drawLineReverse 17s linear infinite, floatLine 20s ease-in-out infinite; 
          stroke-dasharray: 5000; 
        }
        .animate-pulse-line {
          animation: pulse 4s ease-in-out infinite;
        }
        .animate-dot-1 { animation: driftDot 12s ease-in-out infinite; }
        .animate-dot-2 { animation: driftDotSlow 18s ease-in-out infinite; }
        .animate-dot-3 { animation: driftDot 15s ease-in-out infinite 3s; }
        .animate-dot-4 { animation: driftDotSlow 20s ease-in-out infinite 5s; }
        .animate-dot-5 { animation: driftDot 10s ease-in-out infinite 2s; }
        .animate-dot-6 { animation: driftDotSlow 14s ease-in-out infinite 7s; }
      `}</style>

      <svg className="w-full h-full opacity-70" viewBox="0 0 2000 1000" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" data-id="element-7">
        <defs data-id="element-8">
          <filter id="blur-sm" x="-20%" y="-20%" width="140%" height="140%" data-id="element-9">
            <feGaussianBlur stdDeviation="4" data-id="element-10" />
          </filter>
          <filter id="blur-md" x="-20%" y="-20%" width="140%" height="140%" data-id="element-11">
            <feGaussianBlur stdDeviation="8" data-id="element-12" />
          </filter>
          <filter id="blur-lg" x="-20%" y="-20%" width="140%" height="140%" data-id="element-13">
            <feGaussianBlur stdDeviation="14" data-id="element-14" />
          </filter>
          <radialGradient id="glow-center" cx="50%" cy="50%" r="50%" data-id="element-15">
            <stop offset="0%" stopColor="#22c55e" stopOpacity="0.08" data-id="element-16" />
            <stop offset="100%" stopColor="#22c55e" stopOpacity="0" data-id="element-17" />
          </radialGradient>
        </defs>

        {/* Subtle center glow */}
        <ellipse cx="1000" cy="500" rx="600" ry="400" fill="url(#glow-center)" className="animate-pulse-line" data-id="element-18" />

        {/* Background deep lines - thick, blurry, slow */}
        <path className="animate-path-5 text-green-700" d="M -200 800 C 400 900, 800 300, 1400 500 C 1800 600, 2000 400, 2200 700" fill="none" stroke="currentColor" strokeWidth="3" opacity="0.15" filter="url(#blur-md)" data-id="element-19" />
        <path className="animate-path-6 text-green-800" d="M -200 100 C 200 400, 700 -100, 1100 300 C 1500 700, 1800 500, 2200 900" fill="none" stroke="currentColor" strokeWidth="4" opacity="0.1" filter="url(#blur-lg)" data-id="element-20" />

        {/* Mid lines - medium thickness and blur */}
        <path className="animate-path-2 text-green-600" d="M -200 200 C 300 300, 600 100, 1000 400 C 1400 700, 1700 200, 2200 300" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.2" filter="url(#blur-sm)" data-id="element-21" />
        <path className="animate-path-4 text-green-500" d="M -200 500 C 200 400, 600 800, 1200 300 C 1600 100, 2000 400, 2200 500" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.25" data-id="element-22" />
        <path className="animate-path-8 text-green-600" d="M 2200 150 C 1800 350, 1200 50, 800 400 C 400 750, 100 300, -200 600" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.18" filter="url(#blur-sm)" data-id="element-23" />

        {/* Foreground sharp lines - thin, sharp, fast */}
        <path className="animate-path-1 text-green-400" d="M -200 900 C 300 700, 700 900, 1100 600 C 1500 300, 1900 500, 2200 200" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.4" data-id="element-24" />
        <path className="animate-path-3 text-green-500" d="M 200 -200 C 400 300, 800 600, 1200 1200" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.3" filter="url(#blur-sm)" data-id="element-25" />
        <path className="animate-path-7 text-green-400" d="M 2200 800 C 1700 600, 1300 900, 900 500 C 500 100, 200 400, -200 200" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.35" data-id="element-26" />

        {/* Floating dots / particles */}
        <circle className="animate-dot-1" cx="300" cy="200" r="4" fill="#22c55e" opacity="0.3" data-id="element-27" />
        <circle className="animate-dot-2" cx="800" cy="600" r="6" fill="#16a34a" opacity="0.2" filter="url(#blur-sm)" data-id="element-28" />
        <circle className="animate-dot-3" cx="1400" cy="350" r="3" fill="#4ade80" opacity="0.4" data-id="element-29" />
        <circle className="animate-dot-4" cx="1700" cy="700" r="8" fill="#15803d" opacity="0.15" filter="url(#blur-md)" data-id="element-30" />
        <circle className="animate-dot-5" cx="500" cy="800" r="3.5" fill="#22c55e" opacity="0.35" data-id="element-31" />
        <circle className="animate-dot-6" cx="1100" cy="150" r="5" fill="#16a34a" opacity="0.25" filter="url(#blur-sm)" data-id="element-32" />
      </svg>
    </div>;
}